import EditableCell from 'components/EditableCell/EditableCell';

export default EditableCell;
